<template>
  <div class="sm-add-live-answering">
    <h4>Add additional Live Answering recipient{{users.length > 1 ? 's' : ''}}</h4>
    <ul
      ref="list"
      class="sm-add-live-answering__list"
    >
      <li
        v-for="(user, index) in users"
        :key="user.id"
      >
        <input-text
          v-model="user.first_name"
          :name="`first_name_${user.id}`"
          :label="'First name'"
          :data-vv-as="'First name'"
          v-validate="'required'"
          :error="errors.first(`first_name_${user.id}`)"
        />
        <input-text
          v-model="user.last_name"
          :name="`last_name_${user.id}`"
          :label="'Last name'"
          :data-vv-as="'Last name'"
          v-validate="'required'"
          :error="errors.first(`last_name_${user.id}`)"
        />
        <a
          v-if="users.length > 1"
          href="#"
          @click.prevent="deleteItem(index)"
        >
          <include-svg :name="'icon-mail-delete'" />
        </a>
      </li>
    </ul>
    <a
      href="#"
      class="sm-link"
      @click.prevent="addUser"
    >
      <include-svg :name="'icon-plus'" />
      <span>Add one more recipient</span>
    </a>
    <btn-block
      :type="'button'"
      :text="`Add recipient${users.length > 1 ? 's' : ''} for ${price}`"
      :class="{
        'disabled': !users.length
      }"
      @click="submitUsers"
    />
  </div>
</template>

<script>
import InputText from '@/components/InputText';
import {FormatPrice} from '@/utils/general-data';
import Prices from '@/settings/prices';

export default {
  name: 'additional-live-answering',
  components: {
    'input-text': InputText
  },
  data() {
    return {
      users: [
        {
          id: 1,
          first_name: '',
          last_name: ''
        }
      ],
      newUserId: 1
    }
  },
  computed: {
    price() {
      return FormatPrice(Prices.live_answering.user * this.users.length);
    }
  },
  methods: {
    addUser() {
      this.newUserId++;

      this.users.push({
        id: this.newUserId,
        first_name: '',
        last_name: ''
      });

      requestAnimationFrame(() => {
        let newItem = this.$refs.list.querySelector('li:last-child');
        
        newItem.scrollIntoView({
          behavior: 'smooth'
        });
      });
    },
    submitUsers() {
      this.$validator.validate()
        .then(valid => {
          this.users.forEach(user => {
            if (!user.first_name)
              this.errors.add({
                field: `first_name_${user.id}`,
                msg: 'First name is required'
              });

            if (!user.last_name)
              this.errors.add({
                field: `last_name_${user.id}`,
                msg: 'Last name is required'
              });
          });

          if (!valid || this.errors.items.length)
              return;

          this.$emit('submit', this.users.map(user => {
            return {
              first_name: user.first_name,
              last_name: user.last_name
            }
          }));
        });
    },
    deleteItem(index) {
      this.users.splice(index, 1);
    }
  },
}
</script>

<style lang="scss">
@use '@/assets/scss/general/mixins.scss' as *;
@use '@/assets/scss/framework/scss-variables.scss' as *;
@use '@/assets/scss/components/account/_additional-live-answering.scss';
</style>
